import { z } from 'zod';
import { licensureServiceConfigSchema } from '../configurations/LicensureServiceConfig.js';
import { servicesProviderGenericDataSchema } from '../ServicesProviderData.js';
import { Services } from './Services.js';

const servicesProviderLicensureDataSchema = servicesProviderGenericDataSchema.extend({
    config: z.object({
        [Services.LICENSURE]: licensureServiceConfigSchema,
    }),
});

export { servicesProviderLicensureDataSchema };
//# sourceMappingURL=ServicesProviderLicensureData.js.map
